import React, { Component } from 'react';
import { connect } from 'react-redux';
import {InputText} from 'primereact/inputtext';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Dropdown} from 'primereact/dropdown';
import {InputTextarea} from 'primereact/inputtextarea';

import {Button} from 'primereact/button';
import {ProgressSpinner} from 'primereact/progressspinner';
import { DATATABLE_CONFIG, DROPDOWN_CONFIG, POLICY_ATTACHMENT_SUBMENU_ID } from '../../../../shared/Config';
import { HASACCESS, scrollToTop } from '../../../../shared/utility';
import FooterButton from '../../../../shared/UI/FooterButton/FooterButton';
import FileUpload from '../../../../shared/UI/FileUpload/FileUpload';
import {Toast} from 'primereact/toast';
import Messages from '../../../../shared/UI/Messages/Messages';
import * as actions from '../../../../store/actions/index';
import axios from '../../../../axios-url';


class Policy extends Component {
    state = {
        OrgUnitId:null,
        PolicyNo: '',
        SiNo : '',
        type: 'add',
        CompanyPolicyAttachmentId:null,
        file:null,
        filesArray:[],
        loading:false,
        UploadPath: null,
        FileName:null,
        Extension:null,
    }
   
    addPolicy= () => {

        
        var data = {       
            OrgUnitId: this.state.OrgUnitId,
            PolicyNo: this.state.PolicyNo,
            SiNo : this.state.SiNo,
            PolicyDescription: this.state.PolicyDescription,
            UploadPath: this.state.UploadPath,
            FileName:this.state.FileName,
            Extension:this.state.Extension,
            Createdby: 'Admin',
            Createddate: new Date(),
            Isactive : true,
            CompanyId : this.props.loggedUserDetail.CompanyId
        }

        if(this.state.type === 'edit'){
            data.CompanyPolicyAttachmentId = this.state.CompanyPolicyAttachmentId;
            data.Updatedby = (this.props.loggedUserDetail.userName) ?? 'Admin';
            data.Updateddate = new Date();
        }

       
        this.props.processDynamicData('Companypolicyattachments',this.state.type,data,'Company/GetPolicyAttachment');
        
        setTimeout(() => {
            if(this.props.success !== null ){
                this.resetData();
            }
        }, 3000);
       
    }

    

    handleImageChange = (e) => {
        e.preventDefault();
        this.setState({loading:true});
        let file = e.target.files[0];
        let readerShow = new FileReader();
        readerShow.readAsDataURL(file);
        readerShow.onloadend = () => {    
          this.setState({ file: readerShow.result});
        };
        const frmData = new FormData();
        frmData.append('file', file,  file.name );
        return axios.post('/master/api/upload?FolderName=CompanyPolicy', frmData ).then(response =>{
            
            let filesArray = [...this.state.filesArray];
            filesArray.push(response.data);
            this.setState({filesArray:filesArray,loading:false,FileName:response.data.fileName,Extension:response.data.fileExtention,UploadPath:response.data.filePath});  
            

        })
        .catch(err => {
            this.growl.show({severity: 'error', summary: null, detail: 'File Upload Failed'});
            this.setState({loading:false});
        })  
    }


    deleteImage = (path) => {
        let updatedValue = this.state.filesArray.filter((file,index) => {
            return file.filePath !== path
        });
        this.setState({filesArray:updatedValue,UploadPath: null,Extension: null,FileName: null});
    }

   

    orgRender = (rowData) => {

        let value = this.props.GetOrgUnit.filter(filter=>{
            return filter.value === rowData.orgUnitId;
        }).reduce((arr,el)=>{
            return el.label;
        },'');
        return value;

    }

    downloadRender = (rowData) => {
        let name;
        if(rowData.uploadPath !==''){
            name = <Button type="button" icon="pi pi-download" className="p-button-secondary ml1"></Button>
        }else{
            name = 'N/A';
        }
        return  <div className="actionCenter">{name}</div>;

    }

    editItem = (rowData,type) => {
        scrollToTop();
  
        let filesArray = [];
        if(rowData.uploadPath !==null){
            filesArray = [
                {filePath:rowData.uploadPath,fileName:rowData.fileName,fileExtention:rowData.extension}
            ]
        }
        this.setState({type:type,OrgUnitId:rowData.orgUnitId,PolicyNo:rowData.policyNo,SiNo:rowData.siNo,PolicyDescription:rowData.policyDescription,UploadPath:rowData.uploadPath,FileName:rowData.fileName,Extension:rowData.extension,CompanyPolicyAttachmentId:rowData.companyPolicyAttachmentId,filesArray:filesArray})

    }


    delete = (item) => {
        const updatedValue = [{ DeleteID : item}];
        this.props.dynamicDeleteProcess('Companypolicyattachments',updatedValue,'Company/GetPolicyAttachment');
    }


    actionTemplate = (rowData) => {
        return  <div className="actionCenter">
            {(this.getAccess!==undefined && this.getAccess.editAccess!== false) &&
                    <Button type="button" icon="pi pi-pencil"  className="p-button-primary" onClick={()=>this.editItem(rowData,'edit')} ></Button>
            }
            {(this.getAccess!==undefined && this.getAccess.viewAccess!== false) &&
                    <Button type="button" icon="pi pi-eye"  className="p-button-secondary" onClick={()=>this.editItem(rowData,'view')} ></Button>
            }
            {(this.getAccess!==undefined && this.getAccess.deleteAccess!== false) &&
                    <Button type="button" icon="pi pi-trash"  className="p-button-danger" onClick={()=>this.delete(rowData.companyPolicyAttachmentId)} ></Button>
            }
                </div>;
    }


    componentDidMount(){
        this.props.getMasterKeywordList('OrgUnit');
        this.getAccess = HASACCESS(POLICY_ATTACHMENT_SUBMENU_ID);
        this.props.getMasterTableList('Company/GetPolicyAttachment'); 
    }


    updateDetail = (e) => {
        const { name, value} = e.target;
        this.setState({[name]:value});
    }


    resetData = () => {
        this.setState({OrgUnitId:null,PolicyNo:'',SiNo:'',PolicyDescription:'',type:'add',UploadPath:null,FileName:null,Extension:null,CompanyPolicyAttachmentId:null,filesArray:[]})
    }
  
    render() {   


        let addAccess = true;
        let editAccess = true;
        if(this.getAccess!==undefined){
            if(this.getAccess.viewAccess === false){this.props.history.push('/dashboard')}
            addAccess = (this.getAccess.addAccess === true) ? true : false;
            editAccess = (this.getAccess.editAccess === true) ? true : false;
        }
        let accessButton = { addAccess : addAccess, editAccess : editAccess}

        const header = (
            <div style={{'textAlign':'right'}}>
                <InputText type="search" onInput={(e) => this.setState({globalFilter: e.target.value})} placeholder="Search..." />
            </div>
        );

        let releventOption = this.props.GetOrgUnit;
   
   
       
        let isEnabled = (this.state.OrgUnitId!==null) && (this.state.PolicyNo!=='')  && (this.state.SiNo!=='');
        
        let tableData = []    
        if(this.props.tableLists && this.props.tableLists.length > 0){
            tableData = this.props.tableLists;
        }



        return (
            <div className="p-grid approvalPath">
                { this.props.loading && <div className="page-loader"></div>}
                { this.props.error !== null && <Messages type="error" message={this.props.error}/>}
                { this.props.success !== null && <Messages type="success" message={this.props.success}/>}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{position:'relative'}}>
                        <h1>Company Policy Settings</h1>
               
                        <div className="p-grid">
                           

                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label>Select Organization Unit<span className="requiredColor">*</span></label>
                                <div className="mt1 ">
                                <Dropdown placeholder="Select Organization Unit"  name="OrgUnitId"  value={this.state.OrgUnitId} options={releventOption} onChange={this.updateDetail} className="width100" {...DROPDOWN_CONFIG} />
                                </div>                                
                            </div>
                          

                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label>Policy Number<span className="requiredColor">*</span></label>
                                <div className="mt1 ">
                                <ProgressSpinner value={this.state.PolicyNo} placeholder="Policy Number" name="PolicyNo" onChange={this.updateDetail} className="width100"  />
                                </div>                                
                            </div>

                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label>SI Number<span className="requiredColor">*</span></label>
                                <div className="mt1 ">
                                <ProgressSpinner value={this.state.SiNo} placeholder="SI Number" name="SiNo" onChange={this.updateDetail} className="width100"  />
                                </div>                                
                            </div>

                            <div className="p-col-12 p-lg-12">
                            <label>Policy Description</label>
                                <div className="mt1 ">
                                <InputTextarea rows={3}  className="width100" placeholder="Policy Description" name="PolicyDescription" value={this.state.PolicyDescription} onChange={this.updateDetail} />
                                </div>                                
                            </div>


                            

                            <div className="p-col-12  p-md-12 p-lg-8">
                                <div className="mt1 ">
                                <FileUpload handleImageChange={this.handleImageChange} count={1} filesArray={this.state.filesArray} deleteImage={this.deleteImage}/>
                                </div>                                
                            </div>

                            <div className="p-col-12 p-lg-12">
                                <div className="mt1">

                                <FooterButton  access={accessButton}  disabled={!isEnabled} type={this.state.type.toLowerCase()} save={this.addPolicy} reset={this.resetData}  to={""} />


                                </div>                                
                            </div>
                      
                            					 	
                        <div className="p-col-12" style={{marginTop:'2em'}}>


                        <DataTable value={tableData} 
                         globalFilter={this.state.globalFilter} header={header} {...DATATABLE_CONFIG}>
                                <Column field="orgUnitId" header="Organization Unit" body={this.orgRender} />
                                <Column field="policyNo" header="Policy Number" />
                                <Column field="siNo" header="SI Number" />
                                <Column field="uploadPath" header="Download File"  body={this.downloadRender}/>
                                <Column body={this.actionTemplate} header="Action" />
                            </DataTable>
                        </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}



const mapStateToProps = state => {
    return{
        loggedUserDetail : state.auth.userObject,
        userPref : state.auth.userPref,
        loading : state.master.loading,
        error : state.master.error,
        success:state.master.success,
        tableLists : state.master.tableLists,
        GetOrgUnit : (state.keyword.OrgUnit!==undefined) ? state.keyword.OrgUnit : [],
    }
}
  

const mapDispatchToProps = dispatch => {
    return {
        fetchRelavantLists : (value) => dispatch(actions.fetchRelavantLists(value)),
        processDynamicData: (model,type,data,func) => dispatch(actions.processDynamicData(model,type,data,func)),
        getMasterTableList: (table) => dispatch(actions.getMasterTableList(table)),
        dynamicDeleteProcess: (model,data,func) => dispatch(actions.dynamicDeleteProcess(model,data,func)),
        getMasterKeywordList : (value) => dispatch(actions.getMasterKeywordList(value)),
    }
}
  
export default connect(mapStateToProps,mapDispatchToProps)(Policy);